// extracted by mini-css-extract-plugin
module.exports = {"errorResult":"error_errorResult__13FkQ","errorFallback":"error_errorFallback__2E7RI"};